import React, { ReactNode } from 'react'
import ReactDOM from 'react-dom'
import { twMerge } from 'tailwind-merge'

export interface ModalWindowContainerProps {
  isOpened: boolean
  children: ReactNode
  onClose?: () => void
  width?: number
}

export const ModalWindowContainer = ({
  isOpened,
  children,
  onClose,
  width,
}: ModalWindowContainerProps) => {
  const onClick = () => {
    onClose?.()
  }

  return isOpened
    ? ReactDOM.createPortal(
        <div
          className={twMerge(
            'inset-0 z-60 bg-black/15 text-M transition-opacity duration-200',
            isOpened ? 'opacity-100' : 'opacity-0',
          )}
          style={{
            position: 'fixed', //NOTE:  fixed classname is overwritten by common/utils/GlobalStyles.js (62)
          }}
          onClick={e => e.target === e.currentTarget && onClick()}
        >
          <div
            className={twMerge(
              'absolute inset-0 m-auto flex items-center',
              'h-fit max-h-[calc(100vh-200px)]',
            )}
            style={{ maxWidth: `${width}px` }}
          >
            <div
              className={twMerge(
                'flex w-full flex-col items-center overflow-y-auto',
                'rounded-md border border-border200 bg-bgPrimaryBase',
              )}
            >
              {children}
            </div>
          </div>
        </div>,
        document.body,
      )
    : null
}
